import React, { type ReactNode } from 'react';

import Image from '@atlaskit/image';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives/text';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const resultStateContainerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	marginTop: 'space.1000',
	textAlign: 'center',
});

const ImageContainerStyles = xcss({
	marginBottom: 'space.150',
	width: '124px',
	height: '124px',
});

const primaryTextContainerStyles = xcss({
	marginBottom: 'space.150',
	font: 'font.heading.medium',
	fontWeight: 'font.weight.medium',
});

const secondaryTextContainerStyles = xcss({
	marginBottom: 'space.200',
});

type ResultStateProps = {
	imageSrcLight: string | null;
	imageSrcDark: string | null;
	primaryText: ReactNode;
	secondaryText: ReactNode;
	callToAction?: ReactNode;
	testId?: string;
};

export const ResultState = ({
	imageSrcLight,
	imageSrcDark,
	primaryText,
	secondaryText,
	callToAction,
	testId,
}: ResultStateProps): React.JSX.Element => {
	return (
		<Box xcss={resultStateContainerStyles} testId={testId}>
			<Box xcss={ImageContainerStyles}>
				{imageSrcLight &&
					imageSrcDark && (
						// eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details
						<Image src={imageSrcLight} srcDark={imageSrcDark} role="presentation" />
					)}
			</Box>
			<Box xcss={primaryTextContainerStyles}>{primaryText}</Box>
			<Box xcss={secondaryTextContainerStyles}>
				<Text>{secondaryText}</Text>
			</Box>
			{callToAction && <Box>{callToAction}</Box>}
		</Box>
	);
};
